import { ViewChild, Input, Component, OnInit, trigger, state, animate, style, transition, keyframes, ElementRef, Renderer } from '@angular/core';
import { createframe, animateOpen, step1, step2, step3, step4, agreement, inputerror, customgender, termserror, error } from './newuser.animations'

import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { UserService } from '../../services/user.service';
import { Account } from '../../models/account';
import { Country } from '../../models/country';

declare var $: any

@Component({
	selector: 'app-newuser',
	templateUrl: './newuser.component.html',
	providers: [ UserService ],
	inputs: [ 'hideHeader' ],
	animations: [ createframe, step1, animateOpen, step2, step3, step4, agreement, inputerror, customgender, termserror, error ]
})
export class NewUserComponent implements OnInit {

		@Input() hideHeader = false;

		@ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
		
		@ViewChild('Year') year: ElementRef;
		@ViewChild('Month') month: ElementRef;
		@ViewChild('Day') day: ElementRef;

		@ViewChild('MLabel') mlabel: ElementRef;
		@ViewChild('FLabel') flabel: ElementRef;
		@ViewChild('CLabel') clabel: ElementRef;
		
		@ViewChild('Firstname') firstname: ElementRef;

		SWIPES = { LEFT: 'swipeleft', RIGHT: 'swiperight' };

		years = [];
		months = [];
		days = [];
		country: Country;

		constructor(private userService: UserService,
					private sanitizer: DomSanitizer,
					private router: Router,
					private rd: Renderer ) { 
			this.years  = this.generateYears();
			this.months = this.generateMonths();
			this.days  = this.generateDays();
		}

		title: string;
		header: any;
		subtitle: string;
		erruser:  boolean;
		errpwd: boolean;
		erremail: boolean;
		errterms: boolean;
		errtimer: any;
		customgender: boolean;
		headerHeight: any;
		headerAlign: any;
		account: Account;
		countries: Country;

		openYear = false;
		openMonth = false;
		openDay = false;
		openCountries = false;
		
		model = new User();
		state = '2';

		error = '';
		loading = false;
		

		swipe(currentIndex: number, action) {
			if ( currentIndex < 5 ){
				var n = Number(this.state);
				n = n++;
				this.state = n.toString();
			}

 			if (action === this.SWIPES.RIGHT) {
            	const isLast = currentIndex === 4;
       	    	let n = isLast ? '4' : currentIndex + 1;
       	    	this.state = n.toString();
        	}
        	
        	if (action === this.SWIPES.LEFT) {
            	const isLast = currentIndex === 4;
       	    	let n = isLast ? '0' : currentIndex + 1;
       	    	this.state = n.toString();
        	}
		}

		// Select a birthday
		focus(el) {
			let kap = el.toUpperCase();
			this['open'+kap] = false;
			this.rd.invokeElementMethod(this[el].nativeElement,'focus');
		}

		tabFocus(el, e) {
			if ( e.keyCode == 13 || e.keyCode == 9 ) {
				e.preventDefault();
				this.focus(el);
				return false;
			}	
		}

		Step4() {
			if (!this.model.terms) {
				this.errterms = (this.errterms) ? false : true;
			}
				
			if (this.model.terms && this.model.firstname && this.model.surname && this.model.birthday && this.model.sex ) {
				this.state = '4';
			}
		}

		toggleNewsletter() {
			this.model.newsletter = ( this.model.newsletter == true ) ? false : true;
		}

		checkAccount(e?) {
			// if (e.keyCode == 9)
			// 	this.focus();
			// 	return false;
			this.userService.checkUser(this.model.username)
				.subscribe(result => {
					this.erruser = result ? true : false;
				});
		}

		checkAddress(e?) {
			this.userService.checkEmail(this.model.email)
				.subscribe(result => {
					this.erremail = result ? true : false;
				});
		}

		checkPassword(e?) {
			if ( this.model.password )
				this.errpwd = (this.model.password.length < 6) ? true : false;
		}

		blockTab(e) {
			if ( e.keyCode == 9 )
				e.preventDefault();
		}


		createIdentity() {
			// Capture RECAPTCHA request token
			this.model.token = this.captcha.getResponse();
			
			this.loading = true; // Set status

			// Send a request to create the user
			if ( this.model.terms ) {
				Promise.resolve(this.userService.createAccount(this.model)).then((data) => {

					// Was there an error creating the user?
					if ( data.code == 400 ) {
						this.error = data.error; // Set the error message

					} else if (data.code == 200) {
						// The account was created sucessfully
						window.location.pathname = '/account';
					}

					this.captcha.reset();
					this.loading = false; // Reset the status
				});
			} else {
				this.errterms = true;
			}
			

			// Reset the error result after a time on screen
			clearInterval(this.errtimer);
			this.errtimer = setTimeout (() => { this.error = ''; }, 7000);
		}

		// Generate Array of Years
		generateYears(endYear = 1900) {
			var currentYear = new Date().getFullYear(), years = [];
			while ( endYear <= currentYear ) { years.push(currentYear--); }
			return years;
		}

		// Generate Array of Months
		generateMonths() {
			return [ "January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December" ];
		}

		// Generate Array of Years
		generateDays() {
			let day = 1, days = [];
			while ( days.length <= 31 ) { days.push(day++); }
			return days;
		}

		// Generate Array of Months
		generateCountries() {
			Promise.resolve( this.userService.getCountryCodes() ).then( (data) => {
				this.countries = data;
			});
		}

		unfocus() {
			this.openYear = false;
			this.openMonth = false;
			this.openDay = false;
		}

		/* On with the show */
		ngOnInit() {

			this.title = 'IDENTITY';
			this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/art/identity-ski-01.jpeg")' );
			this.subtitle = 'Changing what it means to be an MMORPG.';
			this.headerHeight = '500px';
			// Authorize a user if online
			this.userService.authorizeUser().subscribe((user) =>  {
				this.account = user;
			});

			this.generateCountries();

		}

		ngAfterViewInit() {
			// Prevent Tab jumps messing up Angualar 2 Animations
			$('[name="email"]').on('keydown', function(e) { 
				if (e.keyCode == 9) {
					e.preventDefault();
					$(this).focus();
				}
			});

			$('.birthday input').on('keydown', function(e) { 
				if (e.keyCode == 9) {
					e.preventDefault();
					$(this).focus();
				}
			});
		}


}


// Export the constructor Login form
export class User {
	constructor(
		public username?: string,
		public password?: string,
		public confirmpassword?: string,
		public firstname?: string,
		public surname?: string,
		public email?: string,
		public confirmemail?: string,
		public token?: any,
		public birthday?: any,
		public year?: number,
		public month?: number,
		public day?: number,
		public sex?: string,
		public country?: string,
		public newsletter?: boolean,
		public terms?: boolean
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/create/newuser.component.ts